export function getFontSizeClass(size: 'xs' | 'sm' | 'base' | 'lg') {
  return `text-${size}`;
}
